import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation BulkUpdateResponsiblePersons(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $spaceRecordIds: [ID!]!
    $employeeIds: [ID!]!
    $primaryResponsiblePersonId: ID
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                bulkUpdateResponsiblePersons(
                  spaceRecordIds: $spaceRecordIds
                  employeeIds: $employeeIds
                  primaryResponsiblePersonId: $primaryResponsiblePersonId
                )
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.BulkUpdateResponsiblePersonsMutation,
  undefined,
  graphql.schema.BulkUpdateResponsiblePersonsMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
